export default __webpack_public_path__ + "static/media/infoImg3.4d9cdd91.png";